
// create text area for Textarea
import { cn } from "@/utils/utils.types";
import React from "react";

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { }
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
    return (
        <textarea
            ref={ref}
            {...props}
            className={cn(
                "flex h-11 w-full rounded-lg border border-neutral-300",
                "bg-white px-4 py-2.5 text-sm text-neutral-900",
                "placeholder:text-neutral-400",
                "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-50",
                "transition-all duration-200",
                "shadow-sm hover:border-neutral-400",
                className
            )}
        />
    )
})
Textarea.displayName = "Textarea"
export { Textarea }